import api from '../../utils/api';
import {
    GET_LIST_CUSTOMER_INTERACTIVE_TYPE,
    GET_SPECIFIC_CUSTOMER_INTERACTIVE_TYPE,
    UPDATE_SPECIFIC_CUSTOMER_INTERACTIVE_TYPE,
    CREATE_NEW_CUSTOMER_INTERACTIVE_TYPE,
    REMOVE_CUSTOMER_INTERACTIVE_TYPE,
    GET_CUSTOMER_INTERACTIVE_TYPE_ACTIVE
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListCustomerInteractiveType = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-types', { params: filter }).then(res => {
            dispatch({ type: GET_LIST_CUSTOMER_INTERACTIVE_TYPE, payload: res.data.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getSpecificCustomerInteractiveType = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/interaction-types/${id}`).then(res => {
            dispatch({ type: GET_SPECIFIC_CUSTOMER_INTERACTIVE_TYPE, payload: res.data.data });
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const getCustomerInteractiveTypeActive = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/interaction-types/by-active', { params: filter }).then(res => {
            //console.log(res)
            dispatch({ type: GET_CUSTOMER_INTERACTIVE_TYPE_ACTIVE, payload: res.data });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const createCustomerInteractiveType = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post('/interaction-types', data).then(res => {
            dispatch({ type: CREATE_NEW_CUSTOMER_INTERACTIVE_TYPE, payload: res.data.data });
            NotificationManager.success("Thêm mới bản ghi thành công!");
            resolve(res.data.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}



export const updateCustomerInteractiveType = (id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/interaction-types/${id}`, data).then(res => {
            dispatch({ type: UPDATE_SPECIFIC_CUSTOMER_INTERACTIVE_TYPE, payload: res.data.data });
            NotificationManager.success("Cập nhật bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}

export const removeCustomerInteractiveType = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/interaction-types`, { data: { ids: ids } }).then(res => {
            dispatch({ type: REMOVE_CUSTOMER_INTERACTIVE_TYPE, payload: ids });
            NotificationManager.success("Xoá bản ghi thành công!");
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response.data.msg);
            reject(err);
        })
    })
}
